import { Header } from './components/Header';
import { RenewalProvider } from './context/RenewalContext';
import Renewal from './pages/Renewal';
import { GlobalStyle, Main } from './styles/global';

function App() {
  return (
    <RenewalProvider>
      <GlobalStyle />
      <Main>
        <Header />
        <Renewal />
      </Main>
    </RenewalProvider>
  );
}

export default App;
